import React, {ChangeEventHandler, FC, FocusEventHandler, useState} from 'react';

import { translateError } from '~src/services/translationServices';
import { iconInputImages } from '~src/shared/form/services';

import { ErrorMessage, InputImg, InputWithLabel, LabelBlank, Text } from './inputs.sc';
import { InputIconType } from './IconInput';
import {useTranslation} from "react-i18next";

interface OwnProps  {
  error?: string;
  label: string;
  labelKey: string;
  name: string;
  onBlur?: FocusEventHandler<HTMLTextAreaElement>;
  onChange?: ChangeEventHandler<HTMLTextAreaElement>;
  onFocus?: FocusEventHandler<HTMLTextAreaElement>;
  placeholder?: string;
  type: InputIconType;
  value?: string | number;
}

const TextArea: FC<OwnProps> = ({
  error,
  label,
  labelKey,
  name = '',
  onBlur,
  onChange,
  onFocus,
  placeholder = '',
  type = 'company',
  value
}: OwnProps) => {
  const [focused, setFocused] = useState<boolean>(false);
  const { t } = useTranslation();

  const triggerFocus = (
    newValue: boolean,
    callback: FocusEventHandler<HTMLTextAreaElement> | undefined,
    e: React.FocusEvent<HTMLTextAreaElement>,
  ) => {
    setFocused(newValue);
    if (callback) {
      callback(e);
    }
  }

  const focus= (e: React.FocusEvent<HTMLTextAreaElement>) => {
    triggerFocus(true, onFocus, e);
  };

  const blur = (e: React.FocusEvent<HTMLTextAreaElement>) => {
    triggerFocus(false, onBlur, e);
  };

  return (
    <InputWithLabel $hasValue={!!value ||focused} $valid={!error}>
      <Text
        name={name}
        placeholder={placeholder}
        $valid={!error}
        onChange={onChange}
        value={value}
        onBlur={blur}
        onFocus={focus}
      />
      <LabelBlank $valid={!error} />
      <InputImg name={iconInputImages[type]} $valid={!error} />

      <label data-translation={labelKey}>{label}</label>
      {error && <ErrorMessage>{translateError(t, error)}</ErrorMessage>}
    </InputWithLabel>
  );
};

export default TextArea;
